import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { emailStatusKey, emailStatusValue } from './helpers';
const emailStatusFallback = {
    sent: 'Sent',
    delivered: 'Delivered',
    opened: 'Opened',
    deliveryFailed: 'Delivery failed',
};
// Same translated list values the email overview and email details use for the status.
export const emailStatusMessage = (status) => listItemMsg('emailstatus', emailStatusValue(status), emailStatusFallback[status]);
const EmailStatusLabel = ({ status }) => {
    const intl = useIntl();
    const key = emailStatusKey(status);
    return (_jsxs("span", Object.assign({ className: classNames('label email-status-label', `email-status-${key}`) }, { children: [_jsx("i", { className: classNames('fa margin5R', {
                    'fa-paper-plane-o': key === 'sent',
                    'fa-check': key === 'delivered',
                    'fa-envelope-open-o': key === 'opened',
                    'fa-exclamation-triangle': key === 'deliveryFailed',
                }) }), intl.formatMessage(emailStatusMessage(key))] })));
};
export default EmailStatusLabel;
